import { render } from "./ViewWrapperToggle.vue?vue&type=template&id=7810c4f0"
import script from "./ViewWrapperToggle.vue?vue&type=script&lang=js"
export * from "./ViewWrapperToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__